import { FC } from 'react';
import { Box } from '../BoxNew'
import { DefaultViewStyles } from './styles'

export const SeparatorView: FC<{}> = () => <Box {...DefaultViewStyles.separatorStyle} />
